import { TableRow, Box } from '@mui/material';
import { useAppDispatch } from '~/store';
import { setDownloadList } from '~/store/resource';
import { SelectType } from '~/types/enum';
import { fileSizeFormat } from '~/utils/helper/format';
import { useDownload } from '~/utils/hook/useDownload';
import {
  BaseButton,
  BASE_BUTTON_COLOR,
  BASE_BUTTON_VARIANT,
} from '~/components/Global/Button';
import { downloadTable } from '~/components/Global/Dialog/Dialog.style';
import { useFile } from '~/utils/hook/useFile';
import { TFileCatalog } from '~/store/file/file.type';

export type THandleSelectedList = {
  type: SelectType;
  data?: TFileCatalog;
};

type TProps = {
  data: TFileCatalog;
};

export const FileDownloadDialogItem = ({ data }: TProps) => {
  const dispatch = useAppDispatch();
  const { downloadListChangeListener } = useDownload();
  const { openPath } = useFile();
  const { resource } = data;
  const { fileName, file, key } = resource;
  const { fileSize } = file;
  const { unit, size } = fileSizeFormat(fileSize);
  // TODO: 尚未實作資源更新
  // const updateStatus = getFileUpdateStatus({
  //   uploadedAt: fileUploadTime,
  //   downloadedAt,
  // });

  const handleAction = () => {
    downloadListChangeListener(({ downloadList }) => {
      dispatch(setDownloadList(downloadList));
    });
    if (!key) return;
    const dirPath = key;
    openPath(dirPath);
  };
  // TOOD:更新資源
  // const handleUpdate = () => {
  //   if (!key) return;
  //   update({
  //     filePath: key,
  //     filename: fileName,
  //     resource,
  //     mode: openMode.link,
  //   });
  // };

  return (
    <TableRow key={Math.random()} hover={false}>
      <downloadTable.cell width="100%">{fileName}</downloadTable.cell>
      <downloadTable.cell width="120px">
        {size}
        {unit}
      </downloadTable.cell>
      <downloadTable.cell width="230px">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            // updateStatus === UpdateStatus.old ? 'space-between' : 'flex-end',
          }}
        >
          {/* TODO: 資源更新 */}
          {/* {updateStatus === UpdateStatus.old && (
            <BaseButton
              color={BASE_BUTTON_COLOR.SECONDARY}
              variant={BASE_BUTTON_VARIANT.GHOST}
              text="資源更新"
              onClick={handleUpdate}
            />
          )} */}
          <BaseButton
            variant={BASE_BUTTON_VARIANT.GHOST}
            text="開啟"
            color={BASE_BUTTON_COLOR.SUCCESS}
            width="96px"
            onClick={handleAction}
          />
        </Box>
      </downloadTable.cell>
    </TableRow>
  );
};
